import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {LoaderService} from './loader';
import {buildUrl, URLS} from '../utils/urls';
import {Observable} from 'rxjs';
import {ChargerResponse} from '../types/chargers.model';
import {UserListResponse, UserResponse} from '../types/customers.model';
import {ChargerFormData} from '../types/chargers.model';
import {Response} from '../types/response.model';
import {Vehicle} from '../types/vehicles.model';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient,
              private router: Router,
              private loader: LoaderService) {}
  getChargers() : Observable<ChargerResponse> {
    return this.http.get<ChargerResponse>(URLS.CHARGERS);
  }

  addCharger(chargerData: ChargerFormData): Observable<any> {
    return this.http.post(URLS.ADD_CHARGERS, chargerData);
  }

  // getCustomers() : Observable<UserListResponse> {
  //   return this.http.get<UserListResponse>(URLS.CUSTOMERS);
  // }

  getCustomers(page: number, limit: number): Observable<UserListResponse> {
    return this.http.get<UserListResponse>(URLS.CUSTOMERS,{"params": {page: page.toString(), limit: limit.toString()}});
  }

  getUserDetails(userId: string): Observable<UserResponse> {
    const url: string = buildUrl(URLS.USER_DETAILS, {userId});
    return this.http.get<UserResponse>(url)
  }

  approveVehicle(vehicleId: string): Observable<Response<any>> {
    const url: string = buildUrl(URLS.APPROVE_VEHICLE, {vehicleId});
    return this.http.post<Response<any>>(url, {});
  }

  rejectVehicle(vehicleId: string): Observable<Response<any>> {
    const url: string = buildUrl(URLS.REJECT_VEHICLE, {vehicleId});
    return this.http.post<Response<any>>(url,{});
  }
  updateVehicle(vehicleId: string, data: any): Observable<Response<Vehicle>> {
    const url: string = buildUrl(URLS.UPDATE_VEHICLE, {vehicleId});
    return this.http.patch<Response<any>>(url, data);
  }


}
